import React, { useState, useEffect } from 'react';
import { Container } from 'reactstrap';
import EventNewCard from '../Card/EventNewCard';
import { Auth } from 'aws-amplify';
import config from '../../aws-exports';
import Lottie from 'react-lottie';
import { default as animationData } from '../../assets/loader.json';
import { useLocation } from 'react-router';
import spellBowlImg from '../../assets/gen_images/batchesicon.png';
import mathsImg from '../../assets/gen_images/mathematics.png';
import { cx, css } from '@emotion/css';
import * as assignmentStyles from './assignments.style';
import Amplify from 'aws-amplify';

Amplify.configure(config);

const pageBgStyles = css`
  background-color: #fdfbf7;
  background-image: 
    radial-gradient(at 100% 0%, rgba(241, 102, 2, 0.04) 0px, transparent 50%),
    radial-gradient(at 0% 100%, rgba(244, 203, 14, 0.02) 0px, transparent 50%);
  min-height: 100vh;
  padding-bottom: 100px;
  overflow-x: hidden;
`;

const headerStyles = {
  container: css`
    display: flex;
    justify-content: space-between;
    align-items: flex-end;
    gap: 1rem;
    margin-bottom: 1.5rem;
    margin-top: 1.5rem;
    border-bottom: 1px solid rgba(241, 102, 2, 0.08);
    padding-bottom: 1.2rem;

    @media (max-width: 991px) {
      flex-direction: column;
      align-items: flex-start;
      gap: 1.2rem;
      margin-bottom: 1.5rem;
      padding-bottom: 1.2rem;
    }
  `,
  leftCol: css`
    flex: 1;
    max-width: 850px;
  `,
  topLabel: css`
    font-family: 'Inter', sans-serif;
    font-size: 0.72rem;
    font-weight: 700;
    text-transform: uppercase;
    letter-spacing: 0.18em;
    color: rgba(241, 102, 2, 0.7);
    margin-bottom: 0.6rem;
    display: block;
  `,
  heading: css`
    font-family: 'Outfit', 'Inter', sans-serif;
    font-size: 2.4rem;
    font-weight: 800;
    font-style: italic;
    line-height: 1.05;
    margin: 0 0 0.5rem 0;
    letter-spacing: -0.02em;
    text-transform: uppercase;

    .orange-part {
      color: #f16602;
      margin-right: 0.6rem;
      display: inline-block;
    }

    .outline-part {
      color: transparent;
      -webkit-text-stroke: 1.5px rgba(241, 102, 2, 0.25);
      font-weight: 900;
      display: inline-block;
    }

    @media (max-width: 768px) {
      font-size: 1.8rem;
      
      .outline-part {
        -webkit-text-stroke: 1px rgba(241, 102, 2, 0.25);
      }
    }
  `,
  description: css`
    font-family: 'Inter', sans-serif;
    font-size: 1.05rem;
    color: #554a42;
    line-height: 1.6;
    margin: 0;
    max-width: 700px;
    font-weight: 400;

    @media (max-width: 768px) {
      font-size: 0.95rem;
    }
  `
};

function AssignmentEventsScreen(props) {
  const [events, set_events] = useState([]);
  const [loadedevents, set_loadedevents] = useState(false);
  let data1 = useLocation();

  const getToken = async () => {
    try {
      const res = await Auth.currentSession();
      let accessToken = res.getAccessToken();
      let jwt = accessToken.getJwtToken();
      const user = await Auth.currentAuthenticatedUser();

      if (user.username.includes("Google_")) {
        getEventsfromDB(user.attributes['email'], jwt);
      } else {
        getEventsfromDB(user.username, jwt);
      }
    } catch (err) {
      console.error("Auth error in Assignment Events:", err);
    }
  };

  const getEventsfromDB = async (username, jwt) => {
    const category = data1.state;
    if (!category) return;
    
    var categoryreplace = category.category.replace(/%20/g, ' ');
    const requestOptions = {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Authorization: jwt },
      body: JSON.stringify({
        username: username,
        category: categoryreplace,
        eventtype: 'Assignments',
      }),
    };
    
    try {
      const response = await fetch(`https://api.quizwizard.net/quiz/getassignmentevents`, requestOptions);
      const data = await response.json();

      let loopData = [];
      data.forEach(item => {
        if (item.events) {
          loopData.push(...item.events);
        }
      });
      set_events(loopData);
      set_loadedevents(true);
    } catch (error) {
      console.error("Error fetching assignment events:", error);
      set_loadedevents(true);
    }
  };

  useEffect(() => {
    getToken();
    const categoryName = data1.state?.category || 'Assignments';
    document.title = `${categoryName} | QuizWizard`;
  }, [data1]);

  const defaultOptions = {
    loop: true,
    autoplay: true,
    animationData: animationData,
    rendererSettings: {
      preserveAspectRatio: 'xMidYMid slice',
    },
  };

  const currentCategory = data1.state?.category || 'Challenge';

  return (
    <div className={cx(pageBgStyles)}>
      <Container style={{ marginTop: '2.5rem' }}>
        {/* Curated Header Layout for Assignment Events Screen */}
        <div className={cx(headerStyles.container)}>
          <div className={cx(headerStyles.leftCol)}>
            <span className={cx(headerStyles.topLabel)}>CLASSROOM MISSIONS</span>
            <h1 className={cx(headerStyles.heading)}>
              <span className="orange-part">{currentCategory}</span>
              <span className="outline-part">Missions</span>
            </h1>
            <p className={cx(headerStyles.description)}>
              Complete your active assignments and build your score progress by solving assigned quizzes.
            </p>
          </div>
          {loadedevents && events.length > 0 && (
            <span style={{ 
              background: 'rgba(241, 102, 2, 0.08)', 
              color: '#f16602', 
              padding: '8px 20px', 
              borderRadius: '999px', 
              fontSize: '0.82rem', 
              fontWeight: '700',
              display: 'flex',
              alignItems: 'center',
              gap: '8px',
              border: '1.5px solid rgba(241, 102, 2, 0.18)',
              marginBottom: '3.2rem'
            }}>
              <span style={{ 
                width: '8px', 
                height: '8px', 
                borderRadius: '50%', 
                background: '#f16602', 
                display: 'inline-block',
                boxShadow: '0 0 8px #f16602'
              }}></span>
              {events.length} ACTIVE
            </span>
          )}
        </div>

        {loadedevents ? (
          events.length > 0 ? (
            <div className={cx(assignmentStyles.challengeGrid)} style={{ padding: '0 0 80px 0' }}>
              {events.map((event) => {
                const categoryLower = currentCategory.toLowerCase();
                let customImg = null;
                
                if (categoryLower.includes('spell')) {
                  customImg = spellBowlImg;
                } else if (categoryLower.includes('math') || categoryLower.includes('algebra')) {
                  customImg = mathsImg;
                }

                return (
                  <EventNewCard
                    key={event.id}
                    title={event.name}
                    imgsrc={customImg || `https://api.quizwizard.net/assets/${encodeURIComponent(event.name)}.png`}
                    levels={event.levels}
                    totalquestions={event.totalquestions}
                    event={event}
                  />
                );
              })}
            </div>
          ) : (
            <div style={{ 
              textAlign: 'center', 
              padding: '6rem 2rem', 
              background: '#fffdfb', 
              borderRadius: '2.5rem',
              border: '2.5px dashed rgba(241, 102, 2, 0.15)',
              boxShadow: '0 15px 35px rgba(241, 102, 2, 0.03)'
            }}>
              <div style={{ fontSize: '3.5rem', marginBottom: '1.2rem' }}>🎯</div>
              <h3 style={{ fontWeight: '800', color: '#382110', marginBottom: '0.8rem' }}>No Active Missions Found</h3>
              <p style={{ color: '#594436', maxWidth: '450px', margin: '0 auto', fontSize: '0.95rem', fontWeight: '500', lineHeight: '1.6' }}>
                There are currently no active {currentCategory.toLowerCase()} missions assigned to you. Check back later!
              </p>
            </div>
          )
        ) : (
          <div className="text-center py-5">
            <Lottie options={defaultOptions} height={200} width={200} />
            <p className="mt-3" style={{ fontWeight: '600', color: '#f16602' }}>Loading your missions...</p>
          </div>
        )}
      </Container>
    </div>
  );
}

export default AssignmentEventsScreen;
